import React from 'react';

export default function ExecutionView({ execution }: { execution: any }) {
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div role="status" aria-live="polite">
        Status: {execution?.status || 'UNKNOWN'}
      </div>
      <div>Correlation: {execution?.correlation_id || execution?.execution_id || 'n/a'}</div>
      <details>
        <summary>Raw details</summary>
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{JSON.stringify(execution?.result ?? execution, null, 2)}</pre>
      </details>
    </div>
  );
}


